import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const InformationCircleContained = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="information-circle-contained">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7.625C12.5523 7.625 13 8.07272 13 8.625V8.66455C13 9.21684 12.5523 9.66455 12 9.66455C11.4477 9.66455 11 9.21684 11 8.66455V8.625C11 8.07272 11.4477 7.625 12 7.625ZM12 11C12.5523 11 13 11.4477 13 12L13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V12C11 11.4477 11.4477 11 12 11Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
